import React from 'react';

const SkipTo = () => (
    <a className="skip-to-content-link" href="#main">
    Skip to content
    </a>
);

export default SkipTo;